import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";

const INCLUDED = [
  "understanding the business,",
  "finding the positioning,",
  "developing the story,",
  "designing the customer journey,",
  "building the experience,",
  "connecting the systems,",
  "and measuring what happens afterward.",
];

export default function WhySignature() {
  return (
    <section data-testid="why-signature-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="font-mono text-xs font-semibold tracking-[0.3em] text-gold">WHY SIGNATURE?</p>
          <h2 className="mt-5 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Why does Signature start at $10,000?
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mx-auto mt-10 max-w-2xl text-center">
            <p className="font-display text-xl font-semibold leading-relaxed text-white sm:text-2xl">
              Because we're not pricing the number of pages.
            </p>
            <p className="mt-3 font-display text-xl font-semibold leading-relaxed text-gold sm:text-2xl">
              We're pricing the depth of the engagement.
            </p>
            <p className="mt-8 text-base leading-relaxed text-slate-400">
              Signature includes the work that happens before and around development:
            </p>
            <ul className="mx-auto mt-6 max-w-md space-y-2.5 text-left">
              {INCLUDED.map((item) => (
                <li key={item} className="flex items-baseline gap-3 text-base text-slate-300">
                  <span className="h-1.5 w-1.5 shrink-0 translate-y-[-2px] rotate-45 bg-gold" aria-hidden="true" />
                  {item}
                </li>
              ))}
            </ul>
            <div className="gold-hairline mx-auto mt-10 h-px w-48" aria-hidden="true" />
            <p className="mt-10 text-lg leading-relaxed text-slate-300">
              The website is the visible output.{" "}
              <span className="font-semibold text-white">The strategy behind it is what makes it work.</span>
            </p>
            <Link
              to="/start?package=signature"
              data-testid="why-signature-cta"
              className="group mt-10 inline-flex items-center gap-2.5 rounded-full bg-gold px-8 py-4 text-sm font-bold text-ink shadow-lg shadow-gold/20 transition-colors duration-300 hover:bg-goldlight"
            >
              Tell Us Your Story
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
